import axios from 'CanExConfig/axios'

export const searchDegrees = async term => {
  const response = await axios('/search/degrees', {
    method: 'GET',
    params: {
      term,
    },
  })
  return response.data
}
